module.exports = __webpack_public_path__ + "img/icon-tablet-gray-with-shield.86000f9e.svg";